export default __webpack_public_path__ + "static/media/payment-success-dark.d7277960.png";